module.exports = __webpack_public_path__ + "media/images/academy/qr-50498e6b70c76b32c8992a9fb36d4f68.png";